import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { ModalSize } from '@shared/types/modal-size.type';

@Component({
  selector: 'app-modal-container',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './modal-container.component.html',
  styleUrl: './modal-container.component.css'
})
export class ModalContainerComponent implements AfterViewInit {
  @Input( {required: true} ) title: string = '';
  @Input( {required: true} ) component!: Type<any>;
  @Input(  {required: true} ) data: any;
  @Input() size: ModalSize = 'lg';
  @Input() showActions: boolean = false;

  @ViewChild('content', { read: ViewContainerRef })  content!: ViewContainerRef;

  public closeIcon  : IconDefinition  =  faXmark

  @Input() close!: () => void;
  confirm?: () => void;

  
  ngAfterViewInit() {
    const componentRef = this.content.createComponent(this.component);

    if (this.data) {
      componentRef.setInput('data', this.data);
    }

    componentRef.setInput('cancel', this.close)
  }

  public modalSizes: Record<ModalSize, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
    full: 'max-w-full h-screen'
  };
}
